// authSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  isLoggedIn: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.user = action.payload;
      state.isLoggedIn = true;
    },
    logout: (state) => {
      state.user = null;
      state.isLoggedIn = false;
    },
    updateState: (state, action) => {
      state.user = action.payload;
      state.isLoggedIn = true;
    }
  },
});

export const { loginSuccess, logout,updateState } = authSlice.actions;
export default authSlice.reducer;
